export default "__VITE_ASSET__BEEM1EWO__"